import { Navigate, Route, Routes } from "react-router-dom"

import { AuthLayout } from "layouts/AuthLayout"
import { OAuthLogin } from "pages/common/Auth/OAuthLogin"
import { SmartHomeDevices } from "pages/common/Auth/SmartHomeDevices"

export const OAuthApp = () => {
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path="sign-in" element={<OAuthLogin />} />
      </Route>
      <Route path="devices" element={<SmartHomeDevices />} />
      <Route path="*" element={<Navigate to="/oauth/sign-in" replace />} />
    </Routes>
  )
}
